import { NewsContent } from '../components/NewsContent';
export var RECOMMENDED_CONTENT_TYPES;
(function (RECOMMENDED_CONTENT_TYPES) {
    RECOMMENDED_CONTENT_TYPES["NEWS"] = "news";
})(RECOMMENDED_CONTENT_TYPES || (RECOMMENDED_CONTENT_TYPES = {}));
export const PER_CONTENT_TYPE_COMPONENT = {
    [RECOMMENDED_CONTENT_TYPES.NEWS]: NewsContent,
};
//# sourceMappingURL=index.js.map